import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export const firstLoginSlice = createSlice({
    name: 'firstLogin',
    initialState: {
        firstLogin: false
    },
    reducers: {
        setFirstLogin: (state, action : PayloadAction<boolean>) => {
            state.firstLogin = action.payload;
        }
    }
});

export const { setFirstLogin } = firstLoginSlice.actions;

export default firstLoginSlice.reducer;